import { useEffect, useState } from 'react';
import './index.css';
import 'react-calendar/dist/Calendar.css';
import { Calendar } from '@hassanmojab/react-modern-calendar-datepicker';
import axios from 'axios';

const INFO_BY_DATE_AND_SERVER_URL = 'https://sasovo.cdn-yandex.net/v4/migrations/stats/infoByDateAndServer';
const INFO_BY_DATE_AND_REGION_URL = 'https://sasovo.cdn-yandex.net/v4/migration/stats/regions/infoByDateAndRegion';
const REGIONS_BY_DATE_URL = 'https://sasovo.cdn-yandex.net/v4/migration/stats/regions/date';
const PROVIDERS_BY_DATE_URL = 'https://sasovo.cdn-yandex.net/v4/migration/stats/providers/date';
const MIGRATIONS_BY_DATE_URL = 'https://sasovo.cdn-yandex.net/v4/migration/stats/date';

const ChevronDown = () => {
    return <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2333_27853)">
            <path d="M14.2149 20.5254C14.5079 20.5254 14.8007 20.4082 15 20.1855L24.0704 10.8926C24.2696 10.6934 24.3867 10.4355 24.3867 10.1426C24.3867 9.5332 23.9297 9.06445 23.3204 9.06445C23.0274 9.06445 22.7579 9.18164 22.5585 9.36914L13.582 18.5449H14.8359L5.85937 9.36914C5.67187 9.18164 5.40234 9.06445 5.09766 9.06445C4.48828 9.06445 4.03125 9.5332 4.03125 10.1426C4.03125 10.4355 4.14844 10.6934 4.34766 10.9043L13.418 20.1855C13.6406 20.4082 13.9102 20.5254 14.2149 20.5254Z" fill="black" fill-opacity="0.85" />
        </g>
        <defs>
            <clipPath id="clip0_2333_27853">
                <rect width="20.3555" height="12.4805" fill="white" transform="translate(4.03125 8.04492)" />
            </clipPath>
        </defs>
    </svg>
}

const ChevronUp = () => {
    return <svg width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2333_27824)">
            <path d="M4.4043 17.6777C4.20508 17.8652 4.08789 18.1347 4.08789 18.4394C4.08789 19.0488 4.54492 19.5058 5.1543 19.5058C5.45898 19.5058 5.74023 19.4004 5.91601 19.2011L14.8926 10.0371H13.6387L22.6152 19.2011C22.8027 19.4004 23.084 19.5058 23.377 19.5058C23.9863 19.5058 24.4434 19.0488 24.4434 18.4394C24.4434 18.1347 24.3262 17.8652 24.127 17.6777L15.0567 8.39648C14.8574 8.17383 14.5645 8.04492 14.2715 8.04492C13.9668 8.04492 13.6856 8.17383 13.4746 8.39648L4.4043 17.6777Z" fill="black" fill-opacity="0.85" />
        </g>
        <defs>
            <clipPath id="clip0_2333_27824">
                <rect width="20.3555" height="12.4102" fill="white" transform="translate(4.08789 8.04492)" />
            </clipPath>
        </defs>
    </svg>

}

const ChevronRight = () => {
    return <svg width="12" height="21" viewBox="0 0 12 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2333_27743)">
            <path d="M11.5341 10.2168C11.5341 9.92383 11.417 9.6543 11.1943 9.44336L1.91308 0.34961C1.70215 0.150391 1.44433 0.0449219 1.13965 0.0449219C0.541992 0.0449219 0.0732422 0.501953 0.0732422 1.11133C0.0732422 1.4043 0.19043 1.67383 0.37793 1.87304L8.90918 10.2168L0.37793 18.5605C0.19043 18.7597 0.0732422 19.0176 0.0732422 19.3222C0.0732422 19.9316 0.541992 20.3887 1.13965 20.3887C1.44433 20.3887 1.70215 20.2832 1.91308 20.0722L11.1943 10.9902C11.417 10.7676 11.5341 10.5097 11.5341 10.2168Z" fill="black" fill-opacity="0.85" />
        </g>
        <defs>
            <clipPath id="clip0_2333_27743">
                <rect width="11.4609" height="20.3555" fill="white" transform="translate(0.0732422 0.0449219)" />
            </clipPath>
        </defs>
    </svg>

}



const OutlineProviderMigrationRow = ({ date, migrationData }) => {

    const [selectedType, setSelectedType] = useState('regions'); // providers

    const [isFetched, setFetched] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [isExpanded, setExpanded] = useState(false);

    const [migrationsByRegion, setMigrationsByRegion] = useState([]);
    const [migrationsByProvider, setMigrationByProvider] = useState([]);

    const fetchDate = async () => {
        if (isFetched && !isLoading && isExpanded) {
            setExpanded(false);
            return;
        }

        if (isFetched && !isLoading && !isExpanded) {
            setExpanded(true);
            return
        }

        console.log("Fil")
        if (isLoading) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setLoading(true);

        const request = await axios.post(INFO_BY_DATE_AND_SERVER_URL, {
            date: date, server_id: migrationData.from_server, protocol_type: 'vless'
        }, { headers: { Authorization: `Bearer ${token}` } })
        const response = request.data;
        const info = response.info;
        if (info) {
            setMigrationsByRegion(info.regions);
            setMigrationByProvider(info.providers);
            setExpanded(true);
            setFetched(true);
        }
        setLoading(false);

    }

    if (isExpanded && !isLoading) {
        return <>
            <div className='vless-migration-row' onClick={fetchDate}>
                <div> {migrationData.log_count}</div>
                <div> {migrationData.provider}</div>
                <div> {migrationData.from_server}</div>
                <div> {migrationData.url}</div>
                <div><ChevronUp /></div>
            </div>
            <div className='migration-row-expanded-data'>
                <div className='region-provider-picker-container'>
                    <button onClick={() => setSelectedType('regions')} >by Region</button>
                    <button onClick={() => setSelectedType('providers')} >by Provider</button>
                </div>
                <div>
                    {selectedType === 'regions' && migrationsByRegion.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.region}</div>
                        </div>
                    })}

                    {selectedType === 'providers' && migrationsByProvider.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.provider}</div>
                        </div>
                    })}

                </div>
            </div>
        </>
    }

    return <div className='vless-migration-row' onClick={fetchDate}>
        <div> {migrationData.log_count}</div>
        <div> {migrationData.provider}</div>
        <div> {migrationData.from_server}</div>
        <div> {migrationData.url}</div>
        <div>{isLoading ? <>Loading</> : <ChevronRight />}</div>
    </div>
}

const VlessProviderMigrationRow = ({ date, migrationData }) => {

    const [selectedType, setSelectedType] = useState('regions'); // providers

    const [isFetched, setFetched] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [isExpanded, setExpanded] = useState(false);

    const [migrationsByRegion, setMigrationsByRegion] = useState([]);
    const [migrationsByProvider, setMigrationByProvider] = useState([]);

    const fetchDate = async () => {
        if (isFetched && !isLoading && isExpanded) {
            setExpanded(false);
            return;
        }

        if (isFetched && !isLoading && !isExpanded) {
            setExpanded(true);
            return
        }

        console.log("Fil")
        if (isLoading) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setLoading(true);

        const request = await axios.post(INFO_BY_DATE_AND_SERVER_URL, {
            date: date, server_id: migrationData.from_server, protocol_type: 'vless'
        }, { headers: { Authorization: `Bearer ${token}` } })
        const response = request.data;
        const info = response.info;
        if (info) {
            setMigrationsByRegion(info.regions);
            setMigrationByProvider(info.providers);
            setExpanded(true);
            setFetched(true);
        }
        setLoading(false);

    }

    if (isExpanded && !isLoading) {
        return <>
            <div className='vless-migration-row' onClick={fetchDate}>
                <div> {migrationData.log_count}</div>
                <div> {migrationData.provider}</div>
                <div> {migrationData.from_server}</div>
                <div> {migrationData.url}</div>
                <div><ChevronUp /></div>
            </div>
            <div className='migration-row-expanded-data'>
                <div className='region-provider-picker-container'>
                    <button onClick={() => setSelectedType('regions')} >by Region</button>
                    <button onClick={() => setSelectedType('providers')} >by Provider</button>
                </div>
                <div>
                    {selectedType === 'regions' && migrationsByRegion.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.region}</div>
                        </div>
                    })}

                    {selectedType === 'providers' && migrationsByProvider.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.provider}</div>
                        </div>
                    })}

                </div>
            </div>
        </>
    }

    return <div className='vless-migration-row' onClick={fetchDate}>
        <div> {migrationData.log_count}</div>
        <div> {migrationData.provider}</div>
        <div> {migrationData.from_server}</div>
        <div> {migrationData.url}</div>
        <div>{isLoading ? <>Loading</> : <ChevronRight />}</div>
    </div>
}


const OutlineRegionMigrationRow = ({ date, migrationData }) => {

    const [selectedType, setSelectedType] = useState('regions'); // providers

    const [isFetched, setFetched] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [isExpanded, setExpanded] = useState(false);

    const [migrationsByRegion, setMigrationsByRegion] = useState([]);
    const [migrationsByProvider, setMigrationByProvider] = useState([]);

    const fetchDate = async () => {
        if (isFetched && !isLoading && isExpanded) {
            setExpanded(false);
            return;
        }

        if (isFetched && !isLoading && !isExpanded) {
            setExpanded(true);
            return
        }

        console.log("Fil")
        if (isLoading) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setLoading(true);

        const request = await axios.post(INFO_BY_DATE_AND_SERVER_URL, {
            date: date, server_id: migrationData.from_server, protocol_type: 'vless'
        }, { headers: { Authorization: `Bearer ${token}` } })
        const response = request.data;
        const info = response.info;
        if (info) {
            setMigrationsByRegion(info.regions);
            setMigrationByProvider(info.providers);
            setExpanded(true);
            setFetched(true);
        }
        setLoading(false);

    }

    if (isExpanded && !isLoading) {
        return <>
            <div className='vless-migration-row' onClick={fetchDate}>
                <div> {migrationData.log_count}</div>
                <div> {migrationData.region}</div>
                <div> {migrationData.from_server}</div>
                <div> {migrationData.url}</div>
                <div><ChevronUp /></div>
            </div>
            <div className='migration-row-expanded-data'>
                <div className='region-provider-picker-container'>
                    <button onClick={() => setSelectedType('regions')} >by Region</button>
                    <button onClick={() => setSelectedType('providers')} >by Provider</button>
                </div>
                <div>
                    {selectedType === 'regions' && migrationsByRegion.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.region}</div>
                        </div>
                    })}

                    {selectedType === 'providers' && migrationsByProvider.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.provider}</div>
                        </div>
                    })}

                </div>
            </div>
        </>
    }

    return <div className='vless-migration-row' onClick={fetchDate}>
        <div> {migrationData.log_count}</div>
        <div> {migrationData.region}</div>
        <div> {migrationData.from_server}</div>
        <div> {migrationData.url}</div>
        <div>{isLoading ? <>Loading</> : <ChevronRight />}</div>
    </div>
}

const VlessRegionMigrationRow = ({ date, migrationData }) => {



    const [isFetched, setFetched] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [isExpanded, setExpanded] = useState(false);

    const [migrationsByRegion, setMigrationsByRegion] = useState([]);
    const [migrationsByProvider, setMigrationByProvider] = useState([]);

    const fetchDate = async () => {
        if (isFetched && !isLoading && isExpanded) {
            setExpanded(false);
            return;
        }

        if (isFetched && !isLoading && !isExpanded) {
            setExpanded(true);
            return
        }

        console.log("Fil")
        if (isLoading) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setLoading(true);

        const request = await axios.post(INFO_BY_DATE_AND_REGION_URL, {
            date: date, server_id: migrationData.from_server, protocol_type: 'vless'
        }, { headers: { Authorization: `Bearer ${token}` } })
        const response = request.data;
        const info = response.info;
        console.log({ info })
        if (info) {
            setMigrationsByRegion(info.regions);
            setMigrationByProvider(info.providers);
            setExpanded(true);
            setFetched(true);
        }
        setLoading(false);

    }

    if (isExpanded && !isLoading) {
        return <>
            <div className='vless-migration-row' onClick={fetchDate}>
                <div> {migrationData.log_count}</div>
                <div> {migrationData.region}</div>
                <div> {migrationData.from_server}</div>
                <div> {migrationData.url}</div>
                <div><ChevronUp /></div>
            </div>
            <div className='migration-row-expanded-data'>
                <div>
                    {/* {migrationsByProvider.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.provider}</div>
                        </div>
                    })} */}
                </div>
            </div>
        </>
    }

    return <div className='vless-migration-row' onClick={fetchDate}>
        <div> {migrationData.log_count}</div>
        <div> {migrationData.region}</div>
        <div> {migrationData.from_server}</div>
        <div> {migrationData.url}</div>
        <div>{isLoading ? <>Loading</> : <ChevronRight />}</div>
    </div>
}

const VlessMigrationRow = ({ date, migrationData }) => {

    const [selectedType, setSelectedType] = useState('regions'); // providers

    const [isFetched, setFetched] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [isExpanded, setExpanded] = useState(false);

    const [migrationsByRegion, setMigrationsByRegion] = useState([]);
    const [migrationsByProvider, setMigrationByProvider] = useState([]);

    const fetchDate = async () => {
        if (isFetched && !isLoading && isExpanded) {
            setExpanded(false);
            return;
        }

        if (isFetched && !isLoading && !isExpanded) {
            setExpanded(true);
            return
        }

        console.log("Fil")
        if (isLoading) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setLoading(true);

        const request = await axios.post(INFO_BY_DATE_AND_SERVER_URL, {
            date: date, server_id: migrationData.from_server, protocol_type: 'vless'
        }, { headers: { Authorization: `Bearer ${token}` } })
        const response = request.data;
        const info = response.info;
        if (info) {
            setMigrationsByRegion(info.regions);
            setMigrationByProvider(info.providers);
            setExpanded(true);
            setFetched(true);
        }
        setLoading(false);

    }

    if (isExpanded && !isLoading) {
        return <>
            <div className='vless-migration-row' onClick={fetchDate}>
                <div> {migrationData.log_count}</div>
                <div> {migrationData.comment}</div>
                <div> {migrationData.sni.length > 0 ? migrationData.sni : "-"}</div>
                <div> {migrationData.url}</div>
                <div><ChevronUp /></div>
            </div>
            <div className='migration-row-expanded-data'>
                <div className='region-provider-picker-container'>
                    <button onClick={() => setSelectedType('regions')} >by Region</button>
                    <button onClick={() => setSelectedType('providers')} >by Provider</button>
                </div>
                <div>
                    {selectedType === 'regions' && migrationsByRegion.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.region}</div>
                        </div>
                    })}

                    {selectedType === 'providers' && migrationsByProvider.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.provider}</div>
                        </div>
                    })}

                </div>
            </div>
        </>
    }

    return <div className='vless-migration-row' onClick={fetchDate}>
        <div> {migrationData.log_count}</div>
        <div> {migrationData.comment}</div>
        <div> {migrationData.sni.length > 0 ? migrationData.sni : "-"}</div>
        <div> {migrationData.url}</div>
        <div>{isLoading ? <>Loading</> : <ChevronRight />}</div>
    </div>
}

const OutlineMigrationRow = ({ date, migrationData }) => {

    const [selectedType, setSelectedType] = useState('regions'); // providers

    const [isFetched, setFetched] = useState(false);
    const [isLoading, setLoading] = useState(false)
    const [isExpanded, setExpanded] = useState(false);

    const [migrationsByRegion, setMigrationsByRegion] = useState([]);
    const [migrationsByProvider, setMigrationByProvider] = useState([]);



    const fetchDate = async () => {
        if (isFetched && !isLoading && isExpanded) {
            setExpanded(false);
            return;
        }

        if (isFetched && !isLoading && !isExpanded) {
            setExpanded(true);
            return
        }

        console.log("Fil")
        if (isLoading) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setLoading(true);

        const request = await axios.post(INFO_BY_DATE_AND_SERVER_URL, {
            date: date, server_id: migrationData.from_server, protocol_type: 'shadowsocks'
        }, { headers: { Authorization: `Bearer ${token}` } })
        const response = request.data;
        const info = response.info;
        if (info) {
            setMigrationsByRegion(info.regions);
            setMigrationByProvider(info.providers);
            setExpanded(true);
            setFetched(true);
        }
        setLoading(false);
    }


    if (isExpanded && !isLoading) {
        return <>
            <div className='vless-migration-row' onClick={fetchDate}>
                <div>{migrationData.log_count}</div>
                <div>{migrationData.comment}</div>
                <div>{migrationData.from_server}</div>
                <div>{migrationData.api}</div>
                <div><ChevronUp /></div>
            </div>
            <div className='migration-row-expanded-data'>
                <div className='region-provider-picker-container'>
                    <button onClick={() => setSelectedType('regions')} className='t-button'>by Region</button>
                    <button onClick={() => setSelectedType('providers')} className='t-button'>by Provider</button>
                </div>
                <div>
                    {selectedType === 'regions' && migrationsByRegion.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.region}</div>
                        </div>
                    })}

                    {selectedType === 'providers' && migrationsByProvider.map((region) => {
                        return <div className='vless-migration-row'>
                            <div>{region.migrations}</div>
                            <div>{region.provider}</div>
                        </div>
                    })}

                </div>
            </div>
        </>
    }

    return <div className='vless-migration-row' onClick={fetchDate}>
        <div> {migrationData.log_count}</div>
        <div> {migrationData.comment}</div>
        <div> {migrationData.from_server}</div>
        <div> {migrationData.api}</div>
        <div>{isLoading ? <>Loading</> : <ChevronRight />}</div>
    </div>
}

export default function MigrationAnalyticsV2() {

    const nowDate = new Date();
    const [selectedDate, setSelectedDate] = useState({
        day: nowDate.getDate(),
        month: nowDate.getMonth(),
        year: nowDate.getFullYear()
    });
    const [selectedProtocolType, setProtocolType] = useState("vless"); //
    const [selectedViewType, setSelectedViewType] = useState("servers") // regions // providers
    const [isCalendarOpen, setCalendarOpen] = useState();

    const [migrationsVlessForDate, setMigrationsVlessForDate] = useState([]);
    const [migrationsOutlineForDate, setMigrationsOutlineForDate] = useState([]);

    const [migrationRegionsVlessForDate, setMigrationRegionsVlessForDate] = useState([]);
    const [migrationRegionsOutlineForDate, setMigrationRegionsOutlineForDate] = useState([]);


    const [migrationProvidersVlessForDate, setMigrationProvidersVlessForDate] = useState([]);
    const [migrationProvidersOutlineForDate, setMigrationProvidersOutlineForDate] = useState([]);


    useEffect(() => {
        if (!selectedDate) {
            return;
        }

        if (selectedViewType === 'servers') {
            fetchMigrationsOutline();
            fetchMigrationsVless();
        }

        if (selectedViewType === 'regions') {
            fetchRegionsOutline();
            fetchRegionsVless();
        }

        if (selectedViewType === 'providers') {
            fetchProvidersOutline();
            fetchProvidersVless();
        }


    }, [selectedDate, selectedViewType, selectedProtocolType]);

    const fetchRegionsOutline = async () => {
        if (!selectedDate) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setMigrationRegionsOutlineForDate([])
        const data = { date: selectedDate, protocol_type: "shadowsocks" }
        console.log({ data });
        const request = await axios.post(REGIONS_BY_DATE_URL, data, { headers: { Authorization: `Bearer ${token}` } });
        const response = request.data;

        console.log(response.table)
        setMigrationRegionsOutlineForDate(response.table);
    }

    const fetchRegionsVless = async () => {

        if (!selectedDate) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setMigrationRegionsVlessForDate([])
        const data = { date: selectedDate, protocol_type: "vless" }
        console.log({ data });
        const request = await axios.post(REGIONS_BY_DATE_URL, data, { headers: { Authorization: `Bearer ${token}` } });
        const response = request.data;

        console.log(response.table)
        setMigrationRegionsVlessForDate(response.table);
    }


    const fetchProvidersOutline = async () => {
        if (!selectedDate) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setMigrationProvidersOutlineForDate([])
        const data = { date: selectedDate, protocol_type: "shadowsocks" }
        console.log({ data });
        const request = await axios.post(PROVIDERS_BY_DATE_URL, data, { headers: { Authorization: `Bearer ${token}` } });
        const response = request.data;

        console.log(response.table)
        setMigrationProvidersOutlineForDate(response.table);
    }

    const fetchProvidersVless = async () => {

        if (!selectedDate) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setMigrationProvidersVlessForDate([])
        const data = { date: selectedDate, protocol_type: "vless" }
        console.log({ data });
        const request = await axios.post(PROVIDERS_BY_DATE_URL, data, { headers: { Authorization: `Bearer ${token}` } });
        const response = request.data;

        console.log(response.table)
        setMigrationProvidersVlessForDate(response.table);
    }

    const fetchMigrationsVless = async () => {

        if (!selectedDate) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setMigrationsVlessForDate([])
        const data = { date: selectedDate, protocol_type: "vless" }
        console.log({ data });
        const request = await axios.post(MIGRATIONS_BY_DATE_URL, data, { headers: { Authorization: `Bearer ${token}` } });
        const response = request.data;

        console.log(response.table)
        setMigrationsVlessForDate(response.table);
    }

    const fetchMigrationsOutline = async () => {
        if (!selectedDate) {
            return;
        }
        const token = localStorage.getItem('simple_vpn_token');
        if (token === null || token === undefined) {
            alert('Токен не найден');
            return;
        }
        setMigrationsOutlineForDate([]);
        const data = { date: selectedDate, protocol_type: "shadowsocks" }
        console.log({ data });
        const request = await axios.post(MIGRATIONS_BY_DATE_URL, data, { headers: { Authorization: `Bearer ${token}` } });
        const response = request.data;
        console.log(response.table)
        setMigrationsOutlineForDate(response.table);
    }


    const changeDate = (reactCalendarDate) => {
        setSelectedDate(reactCalendarDate)
    }

    return (
        <div className="content-block t-container">
            <div className="t-content split">
                <div className='t-label'>Protocol</div>
                <div className='migration-analytics-v2-navigation-container'>

                    <div className="select-protocol-type-container">
                        <button onClick={() => setProtocolType('shadowsocks')} className={selectedProtocolType === 'shadowsocks' ? "selected" : ""} >Outline</button>
                        <button onClick={() => setProtocolType('vless')} className={selectedProtocolType === 'vless' ? "selected" : ""} >Vless</button>
                    </div>
                    <button className='select-date-button' onClick={() => setCalendarOpen(!isCalendarOpen)}>
                        {selectedDate.day}.{selectedDate.month + 1}.{selectedDate.year}
                        {isCalendarOpen && <div className='calendar-container'>
                            <Calendar onChange={changeDate}
                                value={selectedDate}
                            /></div>}
                    </button>
                </div>
                <div className='t-label'>View</div>
                <div className="select-protocol-type-container">
                    <button onClick={() => setSelectedViewType('servers')} className={selectedViewType === 'servers' ? "selected" : ""} >Servers</button>
                    <button onClick={() => setSelectedViewType('regions')} className={selectedViewType === 'regions' ? "selected" : ""}>Regions</button>
                    <button onClick={() => setSelectedViewType('providers')} className={selectedViewType === 'providers' ? "selected" : ""}>Providers</button>
                </div>
                {selectedViewType === 'servers' && <>
                    <div className='v2-migrations-table-container'>
                        {selectedProtocolType === 'vless' && <>
                            {migrationsVlessForDate.map((migration) => {
                                return <VlessMigrationRow key={migration.server_id} date={selectedDate} migrationData={migration} />
                            })}
                        </>}

                        {selectedProtocolType === 'shadowsocks' && <>
                            {migrationsOutlineForDate.map((migration) => {
                                return <OutlineMigrationRow date={selectedDate} migrationData={migration} />
                            })}
                        </>}
                    </div>
                </>}
                {selectedViewType === 'regions' && <>
                    <div className='v2-migrations-table-container'>
                        {selectedProtocolType === 'vless' && <>
                            {migrationRegionsVlessForDate.map((migration) => {
                                return <VlessRegionMigrationRow key={migration.server_id} date={selectedDate} migrationData={migration} />
                            })}
                        </>}

                        {selectedProtocolType === 'shadowsocks' && <>
                            {migrationRegionsOutlineForDate.map((migration) => {
                                return <OutlineRegionMigrationRow date={selectedDate} migrationData={migration} />
                            })}
                        </>}
                    </div>
                </>}

                {selectedViewType === 'providers' && <>
                    <div className='v2-migrations-table-container'>
                        {selectedProtocolType === 'vless' && <>
                            {migrationProvidersVlessForDate.map((migration) => {
                                return <VlessProviderMigrationRow key={migration.server_id} date={selectedDate} migrationData={migration} />
                            })}
                        </>}

                        {selectedProtocolType === 'shadowsocks' && <>
                            {migrationProvidersOutlineForDate.map((migration) => {
                                return <OutlineProviderMigrationRow date={selectedDate} migrationData={migration} />
                            })}
                        </>}
                    </div>
                </>}

            </div>
        </div>
    )
}